module.exports = __webpack_public_path__ + "static/media/life-leader-board-banner-desktop.5c3baf94.jpg";